import { useCallback } from "react"
import { atom, useRecoilState } from "recoil"

// lets any component reopen the prompt after a choice is saved
const cookieConsentReopenedAtom = atom({
  key: "cookieConsentReopened",
  default: false,
})

export const useCookieConsentReopen = () => {
  const [isReopened, setIsReopened] = useRecoilState(cookieConsentReopenedAtom)

  const open = useCallback(() => setIsReopened(true), [setIsReopened])
  const close = useCallback(() => setIsReopened(false), [setIsReopened])

  return { isReopened, open, close }
}
